import config from 'services/table/const';
import Action from './table.action';

let table = { ...config };

table.url = '/partner';
table.filter = {type: 'vendor'}
table.columns = {
  codes: {
    title: 'Nama',
    sortable: true,
    width: 200,
    class: '',
    component: (row) => {
      return (
        <div className="table-col row">
          <div className='col-8'>
            <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
              {row?.name}
            </div>
            <small className="info text-uppercase">
              {row?.company_name}
            </small>
          </div>
          <div className='col-2 align-self-center text-end'>
            <span
              className='badge bg-info-lt ms-auto'
            >
              {row?.entities}
            </span>
          </div>
        </div>
      )
    },
  },
  pic_name: {
    title: 'PIC',
    sortable: false,
    format_number: false,
    width: 200,
    class: '',
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.pic_name}
          </div>
          <small className="info text-uppercase">
            PHONE: {row?.pic_phone}
          </small>
        </div>
      );
    },
  },

  partner_id: {
    title: 'Operator',
    sortable: false,
    format_number: false,
    width: 70,
    class: 'text-center',
    classHeader: 'text-center',
    component: (row) => {
      return (
        <span
          className={
            row?.partner_id && row?.partner_id !== ''
              ? 'badge bg-green-lt ms-auto'
              : 'badge bg-red-lt ms-auto'
          }
        >
          {row?.partner_id && row?.partner_id !== ''
            ? 'Ya'
            : 'Bukan'}
        </span>
      );
    },
  },
  action: {
    title: '',
    width: 70,
    class: 'text-end',
    component: (row) => {
      return <Action data={row} />;
    },
  },
};

export default table;
